export default {
  extendedEbayIds: [],
  trackingNumbers: [],
  period: 'last90days',
  statuses: null,
  saleSites: null,
  destinationCountries: null,
  fromAcbt: null,
};
